import { CABIN_CLASS } from '@web-platform/shared-universal-constants/src/cabinClass';
import { RETURN } from '@web-platform/shared-universal-constants/src/tripTypes';
import { USER_SEARCH_VERSION } from '@web-platform/shared-universal-constants/src/userSearch';
import { transformContextUserSearch } from '@web-platform/shared-universal-translations';
import { isAcornRequest } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';
import { GLOBAL } from 'saddlebag-browser';

import type { RawSearchParams } from '@web-platform/shared-universal-types/src/documentStateAcorn';
import type { SearchParams } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

export const getInitialState = (): SearchParams => {
  const $window = GLOBAL.getWindow();

  // Acorn specific initialisation
  if ($window?.__internal && isAcornRequest()) {
    const {
      searchParams: rawSearchParam,
    }: {
      searchParams: RawSearchParams;
    } = $window.__internal;

    return transformContextUserSearch(rawSearchParam);
  }

  // Banana specific initialisation
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return {
    version: USER_SEARCH_VERSION,
    adults: 1,
    child_ages: [],
    cabinClass: CABIN_CLASS.ECONOMY,
    legs: [
      {
        date: '',
        return_date: null,
      },
    ],
    options: {
      // We have no controls for these currently, so default the options
      include_unpriced_itineraries: true,
      include_mixed_booking_options: true,
    },
    alternativeDestinations: false,
    alternativeOrigins: false,
    prefer_directs: false,
    tripType: RETURN,
    fareAttributes: [],
  } as unknown as SearchParams;
};
